const CoreData = () =>
  import('@/views/main/externalStatistics/coreData/CoreData.vue')

export default {
  path: '/main/externalStatistics/coreData',
  name: 'CoreData',
  component: CoreData
}
